/**
 * Application Configuration
 * 
 * This file centralizes all configuration values.
 * In development, values are read from environment variables (via Vite's import.meta.env).
 * In production, these should be set during build time or use defaults.
 */

// Helper to safely get env variable
const getEnvVar = (key: string, defaultValue: string = ''): string => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return (import.meta.env as Record<string, string>)[key] ?? defaultValue;
  }
  return defaultValue;
};

export const config = {
  // API Configuration
  apiBaseUrl: getEnvVar('VITE_API_BASE_URL', 'https://api.kanbanboard.org'),
  
  // Frontend URL
  //frontendUrl: getEnvVar('VITE_FRONTEND_URL', 'http://localhost:3000'),
  frontendUrl: getEnvVar('VITE_FRONTEND_URL', 'https://app.kanbanboard.org'),
  
  // OpenRouter AI Configuration
  openRouterApiKey: getEnvVar('VITE_OPENROUTER_API_KEY', ''),
  openRouterModel: getEnvVar('VITE_OPENROUTER_MODEL', 'openai/gpt-oss-120b:free'),
  
  // Feature Flags
  useMockData: getEnvVar('VITE_USE_MOCK', 'false') === 'true', // Set to true for local development without backend
} as const;

// Type for config object
export type AppConfig = typeof config;
